import React from 'react'
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Menu from './Menu';

const NavMenu = ({ rule, handleMouseEnter, handleMouseLeave, isActive ,isPunchout}) => {

    const attributes = rule?.ContentRuleZone?.[0]?.attributes;
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const childRules = rule?.ContentRuleZone?.[0]?.contents?.ContentFolderZone?.[0]?.childRules;
   
    return (
        <li id={attributes?.displayName ? attributes.displayName : ''}
            className={`nav-item dropdown c-nav-menu-link ${profileDetails && profileDetails.userTypeCheck && Object.keys(profileDetails.userTypeCheck).length > 0 &&
                profileDetails.userTypeCheck.user != "csr" && profileDetails.userTypeCheck.user != "imperson" && isPunchout ?
                (attributes.displayName == "Resources" ? "d-none" : "punchout-width ") : attributes.displayName == "Resources" ? "resource-tab-width" : "product-tab-width"}`}>
            <Link className="nav-link hover-style" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} to={attributes?.link ? attributes.link : "#"} >
                <span className='nav-style c-nav-label-main d-block'>{attributes?.displayName ? attributes.displayName : ''}</span>
                <span className='nav-substyle'>{attributes?.navSubText ? attributes.navSubText : ''}</span>
                <i className="c-arrow-down d-none d-lg-block"></i>
            </Link>
             <div className={`dropdown-menu ${attributes?.displayName == "Resources" ? 'header-resource-hover' : 'header-product-hover'}  c-flyout-container dropdown-tab-style p-0`}>
                <ul className="hover-ul-items list-unstyled">
                    {childRules && childRules.map((rule, index) => {
                        return (
                            <Menu index={index} isActive ={isActive} rule ={rule}/>
                        )
                    })
                    }
                </ul>
            </div> 
        </li>
    )
}

export default NavMenu